import { Component, OnInit, OnDestroy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { MatDialog } from '@angular/material/dialog';
import { MapDialogComponent } from '../map-dialog/map-dialog.component';
import { DataService } from 'src/app/core/services/data-service.service';
import { Subscription } from 'rxjs';
import { createChart, getMappedData } from 'src/app/helperModules/chart.helpers';
import { ISerie, IWidget, IndexFrontend } from 'src/app/shared/models/seriesInfo.interfaces';
import * as moment from 'moment';

@Component({
  selector: 'app-waves',
  templateUrl: './waves.component.html',
  styleUrls: ['./waves.component.scss'],
})
export class WavesComponent implements OnInit, OnDestroy {
  flipped: boolean = false;
  isLastValuesModeled: boolean;
  lastValuesDate: Date;

  chart: Highcharts.Chart;
  chartSettings;
  createChart;
  seriesSettings = [];
  
  dataSubscription: Subscription;
  widgetData: IWidget;
  mappedData: Map<IndexFrontend, ISerie[]> = new Map<IndexFrontend, ISerie[]>();

  constructor(private dataService: DataService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.dataService.getChartSettings().subscribe((settings: any) => {
      this.chartSettings = settings;
    });

    this.dataSubscription = this.dataService.wavesData$.subscribe(widget => {
      if (widget.charts.yAxis.length > 0 && widget.lastValues.length > 0) {
        this.widgetData = widget;
        this.isLastValuesModeled = this.dataService.isWavesModeled;
        this.lastValuesDate = this.widgetData.lastValues
          .find(s => s.indexFrontend === IndexFrontend.MeanWaveDirectionLastValue).date;

        this.mappedData = getMappedData(this.widgetData);
        this.drawChart();
      }
    })
  }

  ngOnDestroy(): void { this.dataSubscription?.unsubscribe() }

  drawChart() {
    this.createChart = createChart.bind(this);
    this.createChart(this.widgetData.charts, this.seriesSettings, this.chartSettings, 's');

    if (this.seriesSettings.length > 0) {
      this.chartSettings.series = this.seriesSettings;
      if (this.chart === undefined) {
        this.chart = Highcharts.chart('wavesChart', this.chartSettings);
      }
      else {
        this.chart.update(this.chartSettings);
      }
    }
  }

  openMap() {
    this.dialog.open(MapDialogComponent, {
      minWidth: '50%',
      maxWidth: '95%',
      minHeight: '50%',
      maxHeight: '95%',
      data: {
        allData: Array.from(this.mappedData.values()).reduce((acc, series) => acc.concat(series)),
      },
      panelClass: 'custom-dialog-container',
    });
  }

  getRotation(indexFrontend: number): string {
    return this.checkExists(indexFrontend) != null 
      ? `${-45 + this.mappedData.get(indexFrontend)[0].lastValue + 180}deg` 
      : '0deg';
  }

  isDataUnderTolerance() : boolean {
    const flattenedAndFiltered = Array.from(this.mappedData.values())
      .reduce((acc, curr) => acc.concat(curr), [])
      .filter(serie => serie.lastValue !== undefined && serie.lastValue !== null);
      
    let isUnderTolerance: boolean = true;
    for (let i = 0; i < flattenedAndFiltered.length; i++) {
      let serie = flattenedAndFiltered[i];
      let tolerance = moment().subtract(serie.communicationTolerance ?? 86400, 'seconds');
      isUnderTolerance = !moment(serie.date).isBefore(tolerance);
    }
  
    return isUnderTolerance;
  }

  checkExists(indexFrontend: IndexFrontend) : boolean { 
    return this.mappedData.has(indexFrontend);
  }
}
